'use strict';

require('@firebase/database');

//# sourceMappingURL=index.cjs.js.map



//////////////////
// WEBPACK FOOTER
// ./~/firebase/database/dist/index.cjs.js
// module id = 782
// module chunks = 0